
import LoadMore from 'vux/src/components/load-more/index.vue'

import { getNewslist } from '@/api/youzheng'
import config from '@/config/index'
export default {
name: 'newsitem',
props: {
CATEGORYCODE: {
type: String,
required: false
},
CHANNELCODE: {
type: String,
required: false
},
loadimmediately: {
type: Boolean,
required: false,
default: false
},
firstload: {
type: Boolean,
required: false,
default: false
},
pageSize: {
type: Number,
required: false,
default: 10
},
haveLoadMore: {
type: Boolean,
required: false,
default: true
}
},
data () {
return {
showlist: [],
loadstate: { curPage: 0, tip: '点击加载更多', showloading: false }
}
},
created () {
if (this.loadimmediately) this.loadmore()
},
components: {
LoadMore
},
methods: {
loadmore () {
if (this.loadstate.tip === '点击加载更多') {
this.loadstate.showloading = true
this.loadstate.tip = '正在加载中...'
this.loadstate.curPage++
setTimeout(() => {
this.getnews(this.loadstate.curPage)
}, 500)
}
if (this.loadstate.tip === '点击去看看更多') {
this.$emit('gotoList')
}
},
getnews (curpage) {
getNewslist({
CATEGORYCODE: this.CATEGORYCODE,
pageSize: this.pageSize,
pageCurrent: curpage,
CHANNELCODE: this.CHANNELCODE,
owner_type: config.owner_type,
searchValue: ''
})
.then(res => {
res = res.obj
if (res && res.length > 0) {
this.showlist = this.showlist.concat(res)
}
this.loadstate.tip =
res.length < this.pageSize
? '已经到底了'
: this.haveLoadMore
? '点击加载更多'
: '点击去看看更多'
this.loadstate.showloading = false
})
.catch(res => {
this.loadstate.curPage--
this.loadstate.showloading = false
if (this.loadstate.curPage < 0) {
this.loadstate.curPage = 0
}
console.log(res, 'getnews false')
})
},
gotoContent (ID) {
this.$router.push({ name: 'yzDetail', params: { type: ID } })
},
linkdetail (link) {
window.location.href = link
}
},
watch: {
firstload (newVal) {
if (newVal) {
this.loadmore()
}
}
}
}
